import SearchPagination from '@bridebook/web/app-basic/components/search/search-pagination/search-pagination.container';
import { getActualCategory } from '@bridebook/web/app-basic/lib/search/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { memo } from 'react';
import { ISearchPageQuery } from '@bridebook/web/app-shared/lib/search/types';

interface IProps {
  fullQuery: ISearchPageQuery;
  facetsParams: string[];
}

const SearchListPagination = ({ fullQuery, facetsParams }: IProps) => {
  const actualCategory = useSelector(getActualCategory);

  return (
    <div className="mt-1 mb-6">
      <SearchPagination
        location={{ query: { slug: fullQuery.slug, area: fullQuery.area } }}
        fullQuery={fullQuery}
        facetsParams={facetsParams}
        actualCategory={actualCategory}
      />
    </div>
  );
};

export default memo(SearchListPagination);
